import { render, staticRenderFns } from "./creatDevise.vue?vue&type=template&id=40f1abac&scoped=true"
import script from "./creatDevise.vue?vue&type=script&crossorigin=anonymous&lang=js"
export * from "./creatDevise.vue?vue&type=script&crossorigin=anonymous&lang=js"
import style0 from "./creatDevise.vue?vue&type=style&index=0&id=40f1abac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1abac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f1abac')) {
      api.createRecord('40f1abac', component.options)
    } else {
      api.reload('40f1abac', component.options)
    }
    module.hot.accept("./creatDevise.vue?vue&type=template&id=40f1abac&scoped=true", function () {
      api.rerender('40f1abac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/devise/creatDevise.vue"
export default component.exports